import type { SubmissionView } from "@/app/reviewQueries";
import { cellById, src, type Notebook, type Task } from "@/kernel/runner";
import { count } from "@/lib/plural";
import { CodeBlock } from "@/ui/CodeBlock";
import { CellBox } from "./CellBox";
import { commentsLabel, type CellRow } from "./model";
import { ThreadView } from "./ThreadView";

export const cellAnchor = (row: CellRow) => `cell-${row.n || row.cellId}`;

/** S7: только ячейки с тредами — код черновика (версия пока не отдаётся),
 *  вывод прогона, тред и ответ студента. */
export function StudentCells({ rows, view, tasks, nb, me, onReply }: { rows: CellRow[]; view: SubmissionView; tasks: Task[]; nb?: Notebook; me: string; onReply: (parentId: string, cellId: string, taskN: number | undefined, body: string) => Promise<void> }) {
  return (
    <div className="flex flex-col gap-3.5">
      {rows.map((row) => {
        const task = tasks.find((t) => t.n === row.n);
        const cell = nb && task ? cellById(nb, task.cell_id) : undefined;
        const replies = row.threads.reduce((a, t) => a + t.replies.length, 0);
        return (
          <CellBox
            key={row.cellId}
            id={cellAnchor(row)}
            row={row}
            right={
              <span className="rounded-[3px] border px-2 py-[3px] font-mono text-[10.5px]" style={{ background: "var(--errsoft)", color: "var(--err)", borderColor: "var(--err)" }}>
                {commentsLabel(row.threads.length)}
                {replies ? ` · ${count(replies, "ответ", "ответа", "ответов")}` : ""}
              </span>
            }
          >
            <div className="flex items-center gap-2.5 border-t border-bd px-3 py-1.5 font-mono text-[11px] text-mut">
              <span>код версии v{view.iteration} — в следующем подпроекте</span>
              {cell && <span>· ниже твой черновик сейчас</span>}
            </div>
            {cell && (
              <div data-testid="draft-code" className="border-t border-bd">
                <CodeBlock code={src(cell)} flat />
              </div>
            )}
            {row.threads.map((t) => (
              <ThreadView key={t.root.id} thread={t} view={view} reply={{ me: { name: me, student: true }, onSend: (body) => onReply(t.root.id, t.root.cell_id, t.root.task_n, body) }} />
            ))}
          </CellBox>
        );
      })}
    </div>
  );
}
